/**
 * The WAITING screen's body, shared by both trees (3056, docs/JOIN-LINKS.md).
 *
 * ITS OWN SCREEN AND NOT A STATE ON `ask`, because it is reachable with no
 * token at all: somebody who asked yesterday and came back to look arrives
 * here from an ordinary boot, through the crewless branch. Folding the two
 * together would mean either a tokenless `ask` or a screen nobody can return
 * to.
 *
 * WHAT IT MUST NOT DO IS LOOK LIKE FAILURE. Its reader has an account, has
 * proven an address, and is in no party — every piece of ordinary chrome would
 * name something they cannot reach, which is why the screen is bare. The copy
 * names WHO is deciding, so the wait has a shape rather than being a spinner
 * with no end.
 *
 * No mirror exists, like `JoinCard` and `AskCard`; it owes the same upstream
 * changelog entry.
 */

import { useQd } from '../store/index.ts';
import { waitingVM } from '../store/selectors.ts';
import { PixelButton } from './PixelButton.tsx';
import type { JoinMetrics } from './JoinCard.tsx';

const MONO = 'var(--gt-font-mono)';

export function WaitingCard({ m }: { m: JoinMetrics }): JSX.Element {
  const s = useQd();
  const v = waitingVM(s);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', padding: m.pad }}>
      <div style={{ fontFamily: MONO, fontSize: m.headFs, color: 'var(--gt-text)', lineHeight: 1.6 }}>
        {v.headline}
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
        <span style={{ fontFamily: MONO, fontSize: m.bodyFs, color: 'var(--gt-muted)', lineHeight: 1.8 }}>
          {v.whoTxt}
        </span>
        <span style={{ fontFamily: MONO, fontSize: m.bodyFs, color: 'var(--gt-muted-2)', lineHeight: 1.8 }}>
          {v.hintTxt}
        </span>
      </div>

      {/* WITHDRAW is what keeps this from being a notification. An ask you can
          only wait on is something done TO you; this one you can take back. */}
      <PixelButton
        label={v.withdrawLbl}
        busy={v.busy}
        onClick={() => void s.withdrawAsk()}
        fs={m.btnFs}
        pad="14px 16px"
        center
        nowrap
      />
    </div>
  );
}
